import { FC, Fragment, useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';

import BaseConditionalRow from 'dashboard/components/WorkflowControlPanel/StepConfigConditional/BaseConditionalRow';
import { ConditionalRule } from 'dashboard/lib/workflows';
import { WorkflowSchema } from 'dashboard/models/workflow';
import Spacer from 'design-system/components/Spacer';
import { JsonSchema } from 'lib/json-schema';

interface AndRulesSectionProps {
  andRules: ConditionalRule[];
  jsonSchema: JsonSchema;
  orIndex: number;
  tokensToDisplayValue: Record<string, string>;
  workflowSchema: WorkflowSchema;
  deleteConditional: (andIndex: number) => () => void;
  updateConditionalRule: (andIndex: number) => (conditional: ConditionalRule) => void;
}

const AndRulesSection: FC<AndRulesSectionProps> = ({
  andRules,
  jsonSchema,
  orIndex,
  tokensToDisplayValue,
  workflowSchema,
  deleteConditional,
  updateConditionalRule,
}) => {
  const [keys, setKeys] = useState(andRules.map(() => uuid()));
  const [internalAndRules, setAndRules] = useState(andRules);

  useEffect(() => {
    const newKeys = keys.slice();
    internalAndRules.forEach((_, index) => {
      if (!newKeys[index]) {
        newKeys.push(uuid());
      }
    });
    setKeys(newKeys);
  }, [internalAndRules.length]);

  useEffect(() => {
    setAndRules(andRules);
  }, [andRules]);

  return (
    <>
      {internalAndRules.map((andRule, andIndex) => (
        <Fragment key={keys[andIndex]}>
          <BaseConditionalRow
            andRule={andRule}
            jsonSchema={jsonSchema}
            tokensToDisplayValue={tokensToDisplayValue}
            workflowSchema={workflowSchema}
            orIndex={orIndex}
            andIndex={andIndex}
            updateConditionalRule={updateConditionalRule(andIndex)}
            deleteConditional={() => {
              setKeys([...keys.slice(0, andIndex), ...keys.slice(andIndex + 1)]);
              setAndRules([
                ...internalAndRules.slice(0, andIndex),
                ...internalAndRules.slice(andIndex + 1),
              ]);
              deleteConditional(andIndex)();
            }}
          />
          <Spacer height={2} />
        </Fragment>
      ))}
    </>
  );
};

export default AndRulesSection;
